<template>
    <div>
        <footer class="footer bg-white">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="footer-copyright text-center border-top border-gray-light">
                            <span class="font-family-alt letter-spacing-1 text-gray-dark text-small text-uppercase">
                                {{ year }} &copy; Volkswagen ErhvervsCenter {{ this.$route.meta.retailerName }}. Udviklet af <a target="_blank" rel="noopener" href="https://deveo.dk"><u>Deveo</u></a>.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <a href="#page-top" class="page-scroll scroll-to-top"><i class="fa fa-angle-up"></i></a>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                year: ''
            }
        },
        mounted () {
            this.getYear()
        },
        methods: {
            getYear () {
                let year = new Date().getFullYear()
                this.year = year
            }
        }
    }
</script>



// WEBPACK FOOTER //
// footer.vue?a1e69484